import { render, staticRenderFns } from "./ProductsQuickSearch.vue?vue&type=template&id=48379f32"
import script from "./ProductsQuickSearch.vue?vue&type=script&lang=js"
export * from "./ProductsQuickSearch.vue?vue&type=script&lang=js"
import style0 from "./ProductsQuickSearch.vue?vue&type=style&index=0&id=48379f32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports